const selectors = {
  triggers: '[data-tabbed-page-trigger]',
  pageWrappers: '[data-tabbed-page-handle]'
};
export default function init ({ el, context }) {
	const nodeSelectors = {
    triggers: el.querySelectorAll(selectors.triggers),
    pageWrappers: el.querySelectorAll(selectors.pageWrappers)
  };
  for (var i = nodeSelectors.triggers.length - 1; i >= 0; i--) {
  	nodeSelectors.triggers[i].addEventListener('click', async (e) => {
  		e.preventDefault();
  		let thisButton = e.currentTarget
  		let tabbedPageHandle = thisButton.dataset.tabbedPageHandle;
      let tabbedPageWrapper = el.querySelector(`.tabbed-page__body__page[data-tabbed-page-handle="${tabbedPageHandle}"]`);
      let currentActivePage = el.querySelector(`.tabbed-page__body__page[aria-hidden="false"]`);
      let currentActivePageTrigger = el.querySelector(`[data-tabbed-page-trigger][data-active-page-trigger="true"]`);
  		if(thisButton.dataset.activePageTrigger === "true"){
  			return true;
  		}
  		thisButton.dataset.activePageTrigger = "true"
      currentActivePageTrigger.dataset.activePageTrigger = "false";
      currentActivePage.setAttribute('aria-hidden', 'true');
      tabbedPageWrapper.setAttribute('aria-hidden', 'false');
  	});
  }
}